module.exports = __webpack_public_path__ + "img/completed-requests.0add8cc4.svg";